import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ISource } from 'entities/Source/model/types';

import { EOnboardingStates, EOnboardingSteps, EResultTypes, IOnboardingState } from './types';

const initialState: IOnboardingState = {
	modalIsOpened: false,
	state: EOnboardingStates.STEPS,
	step: EOnboardingSteps.FIRST,
	createdSource: null,
	resultType: EResultTypes.NEED_SOURCE,
};

export const onboardingSlice = createSlice({
	name: 'onboarding',
	initialState,
	reducers: {
		setModalState: (state, action: PayloadAction<EOnboardingStates>) => {
			state.state = action.payload;
		},
		setStep: (state, action: PayloadAction<EOnboardingSteps>) => {
			state.step = action.payload;
		},
		closeOnboardingModal: (state) => {
			state.modalIsOpened = false;
		},
		openOnboardingModal: (state) => {
			state.modalIsOpened = true;
		},
		setCreatedSource: (state, action: PayloadAction<ISource | null>) => {
			state.createdSource = action.payload;
		},
		setResultType: (state, action: PayloadAction<EResultTypes>) => {
			state.resultType = action.payload;
		},
	},
});

export default onboardingSlice.reducer;
export const { setModalState, setStep, openOnboardingModal, closeOnboardingModal, setCreatedSource, setResultType } =
	onboardingSlice.actions;
